<template id="modal-confirmation">
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10"
              :class="{'bg-red-100': type === 'danger'}"
            >
              <svg
                class="h-6 w-6"
                :class="{'text-red-600': type === 'danger'}"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                <div v-if="(wavesLinked && wavesLinked.length > 0) || (bannersLinked && bannersLinked.length > 0) || (npsLinked && npsLinked.length > 0)">There are items linked to this bubble</div>
                <div v-else>Please confirm your choice</div>
              </h3>
              <br>
              <div v-if="(wavesLinked || bannersLinked || npsLinked)">
                <div v-if="(wavesLinked.length > 0 || bannersLinked.length > 0 || npsLinked.length > 0)">

                  <p v-if="wavesLinked.length > 0 && bannersLinked.length > 0" class="text-base text-grey-1000">Some Banners, Waves, and Surveys are linked to that bubble</p>
                  <p v-else-if="wavesLinked.length > 0 && npsLinked.length > 0" class="text-base text-grey-1000">Some Waves and Surveys are linked to that bubble</p>
                  <p v-else-if="bannersLinked.length > 0 && npsLinked.length > 0" class="text-base text-grey-1000">Some Banners and Surveys are linked to that bubble</p>
                  <p v-else-if="wavesLinked.length > 0" class="text-base text-grey-1000">Some Waves are linked to that bubble</p>
                  <p v-else-if="bannersLinked.length > 0" class="text-base text-grey-1000">Some Banners are linked to that bubble</p>
                  <p v-else-if="npsLinked.length > 0" class="text-base text-grey-1000">Some Surveys are linked to that bubble</p>
                  <table class="py-3 leading-none">
                    <thead>
                      <tr>
                        <th class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase">Name</th>
                        <th class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase">Code</th>
                        <th class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase">Status</th>
                        <th class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase">lien</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="wave in wavesLinked" :key="wave.id" class="py-5 bg-white text-sm">
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm"><div class="my_overflow">{{wave.name}}</div></td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{wave.code}}</td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{wave.status}}</td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm"><router-link :to="{name: 'Wave' ,params: {site: site.sitekey, id: wave.id } }"> <font-awesome-icon icon="pencil-alt"></font-awesome-icon></router-link></td>
                      </tr>
                      <tr v-for="banner in bannersLinked" :key="banner.id" class="py-5 bg-white text-sm">
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm"><div style="overflow:hidden; width:100%; height:16px">{{banner.name}}</div></td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{banner.code}}</td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{banner.status}}</td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm"><router-link :to="{name: 'BannerEdit' , params: {site: site.sitekey, id: banner.id } }"> <font-awesome-icon icon="pencil-alt"></font-awesome-icon></router-link></td>
                      </tr>
                      <tr v-for="nps in npsLinked" :key="nps.id" class="py-5 bg-white text-sm">
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm"><div style="overflow:hidden; width:100%; height:16px">{{nps.name}}</div></td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{nps.code}}</td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{nps.status}}</td>
                        <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm"><router-link :to="{name: 'Survey' , params: {site: site.sitekey, id: nps.id } }"> <font-awesome-icon icon="pencil-alt"></font-awesome-icon></router-link></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 ">
          <p class="text-sm text-grey-1000"> {{ message }}</p>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            @click="executeAction()"
            type="button"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
            :class="{'bg-red-600 hover:bg-red-700 focus:ring-red-500': type === 'danger'}"
          >
            {{ messageAction }}
          </button>
          <button
            @click="close()"
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'modal',
  props: {
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    messageTitle: {
      type: String,
      required: true
    },
    messageAction: {
      type: String,
      required: true
    },
    wavesLinked: {
      type: Array,
      required: false
    },
    bannersLinked: {
      type: Array,
      required: false
    },
    npsLinked: {
      type: Array,
      required: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  methods: {
    executeAction () {
      this.$emit('execute', true)
      this.close()
    },
    close () {
      this.$emit('close', false)
    }
  }
}

</script>

<style scoped>
.my_overflow {
  overflow:hidden;
  height:16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/others/utils/ModalConfirmation.vue